function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {};

    this.images = {'silver': 'url("//picturekeeper.com/cdn/shop/files/silver_68x.png?v=10451812349728966923")','gray': 'url("//picturekeeper.com/cdn/shop/files/gray_68x.png?v=15207075808216139254")','pink': 'url("//picturekeeper.com/cdn/shop/files/pink_68x.png?v=10878409884539753875")','berry': 'url("//picturekeeper.com/cdn/shop/files/berry_68x.png?v=12418729579605388048")','gold': 'url("//picturekeeper.com/cdn/shop/files/gold_68x.png?v=15364375872694073919")','turquoise': 'url("//picturekeeper.com/cdn/shop/files/turquoise_68x.png?v=18352827703460989616")','black-case': 'url("//picturekeeper.com/cdn/shop/files/black-case_68x.png?v=1035323083339508181")','pink-case': 'url("//picturekeeper.com/cdn/shop/files/pink-case_68x.png?v=5879699875999716681")','tangerine-case': 'url("//picturekeeper.com/cdn/shop/files/tangerine-case_68x.png?v=12002051760212822649")','blue': 'url("//picturekeeper.com/cdn/shop/files/blue_68x.png?v=5877091988206107563")','red': 'url("//picturekeeper.com/cdn/shop/files/red_68x.png?v=5404834748447651233")','navy': 'url("//picturekeeper.com/cdn/shop/files/navy_68x.png?v=7251881814608592004")','rose-gold': 'url("//picturekeeper.com/cdn/shop/files/rose-gold_68x.png?v=16906391103297694413")','tangerine': 'url("//picturekeeper.com/cdn/shop/files/tangerine_68x.png?v=9699258864680522171")','purple': 'url("//picturekeeper.com/cdn/shop/files/purple_68x.png?v=12866945602533759330")','bronze': 'url("//picturekeeper.com/cdn/shop/files/bronze_68x.png?v=10200877398779096800")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
